import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Divider,
  Button,
  Input,
  Tooltip,
} from 'antd';

import {
  formatCell,
  sorter,
  createColumns
} from '../../../helpers';

import DataTable from '../../DataTable';
import {
  Dialog,
  Spinner,
} from '../../UI';

import styles from './Details.module.css';

const { Title } = Typography;
const { TextArea } = Input;

class Details extends PureComponent {
  state = {
    show: false,
    aff: '',
    paymentType: '',
    paymentDetails: '',
  };

  componentDidMount () {
    this.props.fetchUserInfo(() => {
      this.props.fetchPaymentsDetails();
    });
  };

  open = (event, modal) => {
    const modalId = modal;
    const { rowid } = event.target.dataset;
    const name = event.target.name;
    const index =  this.props.paymentsDetails.data.length > 0 && this.props.paymentsDetails.data.findIndex(el => el.rowId === parseInt(rowid));
    const { aff } = this.props.paymentsDetails.data[index];
    const description = this.props.paymentsDetails.data[index][name];

    const payload = {
      aff,
      paymentType: name,
      paymentDetails: description
    };

    this.setState({
      [modalId]: !!modalId,
      aff: payload.aff,
      paymentType: payload.paymentType,
      paymentDetails: payload.paymentDetails,
    });
  };

  close = (event, cb) => {
    this.setState({
      show: false,
      aff: '',
      paymentType: '',
      paymentDetails: '',
    });

    if (cb) {
      this.props.fetchPaymentsDetails();
    }
  };

  handleEdit = () => {
    const payload = {
      aff: this.state.aff,
      paymentType: this.state.paymentType,
      paymentDetails: this.state.paymentDetails
    };

    this.props.setPaymentDetails(
      payload,
      (event) => this.close(event, true)
    );
  };

  handleChange = (event) => {
    const { value } = event.target;

    this.setState({
      paymentDetails: value
    });
  };

  render() {
    const {
      pageLoading,
      loading,
      paymentsDetails,
      paymentsDetails: {
        fields,
        tableName,
      }
    } = this.props;
    const { paymentDetails, show } = this.state;
    const fieldsObj = fields && fields[0];

    const renderTableCell = (text, record, item) => {
      const { rowId } = record;
      let content = text;
      if (item.button !== undefined) {
        if (item.button.type === 'link') {
          const innerContent = item.button.id === 'wire_details' ? (
            <Tooltip
              title={text}
              placement="left"
            >
              <span className="text-ellipsis">{text}</span>
            </Tooltip>
          ) : (
            <span>{text}</span>
          );
          const button = (
            <Button
              type="link"
              className={styles['edit-btn']}
              data-rowid={rowId}
              onClick={(event) => this.open(event, 'show')}
              name={item.button.id}
            >
              Edit
            </Button>
          );

          content = (
            <div className={styles.description}>
              {innerContent}
              {button}
            </div>
          );
        }
      }

      return formatCell(item, content);
    };

    const columns = createColumns(
      fieldsObj,
      sorter,
      renderTableCell,
    );

    let content = <Spinner />;
    if (!pageLoading) {
      content = (
        <>
          <Divider />
          <DataTable
            loading={loading}
            table={{
              columns: columns,
              data: paymentsDetails,
              tableName: tableName,
              toolbar: {
                titleExport: 'Payments History Export',
              }
            }}
          />
        </>
      )
    }

    const description = (
      <TextArea
        rows={3}
        value={paymentDetails}
        onChange={this.handleChange}
      />
    );

    return (
      <div>
        <Title>Details</Title>
        {content}

        <Dialog
          title="Payment Details"
          visible={show}
          onOk={this.handleEdit}
          onCancel={this.close}
          content={description}
          width={1170}
        />
      </div>
    );
  }
}

Details.propTypes = {
  pageLoading: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  paymentsDetails: PropTypes.object.isRequired,
  fetchUserInfo: PropTypes.func.isRequired,
  fetchPaymentsDetails: PropTypes.func.isRequired,
};

Details.defaultProps = {
  paymentsDetails: {}
};

export default Details;
